import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/** Tailwind 클래스 병합 — 동적 클래스 + 조건부 클래스 안전 결합. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
